import { createContext } from 'react'

import type { Sizing } from './Table'

export const Context = createContext<Partial<Context>>({ sizing: [] })

///////// IMPLEMENTATION /////////

type Context = { sizing: Array<Sizing> }
